<script lang="ts" setup>
import {useCartStore} from "@/stores/cart";
import CartItemRow from "@/components/cart/CartItemRow.vue";
import {computed} from "vue";
import type {TProduct} from "@/components/cart/CartPage.vue";

const props = withDefaults(defineProps<{ products: TProduct[], showTitle?: boolean }>(), {
  showTitle: true
})

const cartStore = useCartStore()

const product = (productId: string) => props.products.find((product: TProduct) => +product.id === +productId)
const isPriceColumnShown = computed(() => props.products.some((product: TProduct) => product.price))
</script>

<template>
  <template v-if="!cartStore.areFavoritesExists">
    <div class="p-5 pt-[30px]">
      <div :class="{'min-h-[49.938rem]': props.showTitle}" class="grid place-items-center font-myriadPro">
        <div class="flex flex-col items-center gap-2.5">
          <h3 class="text-[38px] desktop:text-[2.5rem] leading-[90%] text-center">Вы не добавили ни одного товара</h3>
          <p class="text-[18px] desktop:text-xl leading-none text-center">Подберите интересующие вас товары в разделе каталог</p>
          <a class="max-desktop:uppercase max-desktop:w-full inline-flex desktop:mt-2.5 items-center rounded-[3px] transition-colors disabled:pointer-events-none disabled:opacity-50 bg-[hsl(var(--roke-text-blue))] text-white justify-center text-lg font-semibold h-14 px-5 hover:bg-white hover:text-[hsl(var(--roke-text-blue))]" href="/catalog">
            <span class="mt-0.5">Перейти в каталог</span>
          </a>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div :class="{'desktop:p-5': props.showTitle}" class="px-2.5 pb-2.5 grid grid-cols-1 max-desktop:pt-[100px]">
      <h1 v-if="props.showTitle" class="text-[50px] leading-none desktop:text-[105px] desktop:leading-[94.5px] font-centuryGothic font-bold uppercase">Избранное</h1>
      <div class="desktop:grid gap-[1.25rem] relative">
        <button v-if="props.showTitle" class="absolute right-0 -top-2 transition-colors hover:text-[hsl(var(--roke-text-blue))]" type="button" @click="cartStore.clearFavorites">Очистить избранное</button>
        <table :class="{'mt-2.5 desktop:mt-[30px]': props.showTitle}" class="table-auto border-collapse desktop:border text-xl font-myriadPro h-fit">
          <thead class="max-desktop:hidden">
          <tr class="bg-[hsl(var(--roke-fill-grey))] leading-[90%]">
            <th class="border px-5 font-normal h-[53px] text-[20px] leading-[18px]" colspan="2">Товар</th>
            <th class="border px-5 font-normal h-[53px] text-[20px] leading-[18px]">Описание</th>
            <th class="border font-normal h-[53px] text-[20px] leading-[18px]">Комментарий</th>
            <th v-if="isPriceColumnShown" class="border px-5 font-normal h-[53px] text-[20px] leading-[18px]">Цена</th>
            <th class="border px-5 font-normal h-[53px] text-[20px] leading-[18px]">Купить</th>
          </tr>
          </thead>
          <tbody class="text-center text-2xl max-desktop:flex flex-col gap-2.5">
          <CartItemRow v-for="(item, n) in cartStore.favorites" :key="n" :favorite="true" :product="product(item) as TProduct"/>
          </tbody>
        </table>
      </div>
    </div>
  </template>
</template>